#button {
  height: 48px;
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
}

#icon {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

#button.small #icon {
  width: 24px;
  height: 24px;
}

#button.small #icon svg {
  width: 12px;
  height: 12px;
}

#button.secondary.ghost #icon {
  border: 1px solid var(--grid-border-action-secondary-ghost);
}

#button.secondary.ghost:hover #icon {
  border-color: var(--grid-border-action-secondary-ghost-hover);
}

#button.secondary.ghost #icon path {
  fill: var(--grid-content-on-action-primary-ghost);
}

#button.secondary.ghost:hover #icon path {
  fill: var(--grid-content-on-action-primary-ghost-hover);
}
